// 덴클 케어 공개 페이지(/care/*) 공용 껍데기 — 앱·스토어 링크용, 비로그인 공개. 인라인 스타일.
import React from 'react';
import SiteFooter from '../common/SiteFooter';
import { CARE_APP_NAME } from '../../config/careApp';

function CarePageShell({ title, meta, children }) {
    return (
        <div style={S.body}>
            <div style={S.container}>
                <div style={S.header}>
                    <div style={S.brand}>{CARE_APP_NAME}</div>
                    <h1 style={S.title}>{title}</h1>
                    {meta && <p style={S.meta}>{meta}</p>}
                </div>
                {children}
            </div>
            <SiteFooter />
        </div>
    );
}

export const CS = {
    h2: { fontSize: 16, fontWeight: 800, marginTop: 24, marginBottom: 8, color: '#0f172a' },
    p: { fontSize: 14, color: '#334155', lineHeight: 1.8, margin: '0 0 6px' },
    box: { fontSize: 14, color: '#0f172a', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '12px 14px', marginTop: 8, lineHeight: 1.8 },
    link: { color: '#0369a1', textDecoration: 'underline', fontSize: 14 },
    pre: { fontSize: 14, color: '#1e293b', lineHeight: 1.85, whiteSpace: 'pre-wrap', wordBreak: 'keep-all', margin: 0, fontFamily: 'inherit' },
    pending: { fontSize: 15, color: '#475569', background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 10, padding: '18px 16px', textAlign: 'center', lineHeight: 1.7 },
};

const S = {
    body: { backgroundColor: '#f8fafc', minHeight: '100vh', fontFamily: "'Apple SD Gothic Neo', 'Malgun Gothic', sans-serif", color: '#0f172a', padding: '32px 16px 0', boxSizing: 'border-box' },
    container: { maxWidth: 760, margin: '0 auto 24px', backgroundColor: '#fff', padding: '32px 24px', borderRadius: 14, border: '1px solid #e2e8f0', boxSizing: 'border-box' },
    header: { textAlign: 'center', marginBottom: 24, paddingBottom: 18, borderBottom: '2px solid #0f6b5c' },
    brand: { fontSize: 13, fontWeight: 700, color: '#0f6b5c', marginBottom: 4 },
    title: { fontSize: 24, fontWeight: 900, margin: '0 0 6px' },
    meta: { fontSize: 12.5, color: '#64748b', margin: 0 },
};

export default CarePageShell;
